<template>
  <admin-page-frame :title="title" :description="description">
    <template v-if="showToolbar" #toolbar>
      <div class="crud-opts">
        <span class="crud-opts-left">
          <el-button type="primary" size="mini" icon="el-icon-plus" disabled>新增（待接入 API）</el-button>
        </span>
      </div>
      <div v-if="showFilter" class="filter-container">
        <el-input
          v-model="keyword"
          clearable
          size="small"
          placeholder="关键词搜索"
          class="filter-item"
          style="width: 200px; margin-right: 10px;"
        />
        <el-button class="filter-item" size="mini" type="primary" icon="el-icon-search" disabled>查询</el-button>
      </div>
    </template>

    <el-alert
      title="Phase 1 页面骨架已就绪，后端 /schools/h5admin API 接入后可替换占位内容。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 12px;"
    />

    <el-table :data="[]" border size="small" empty-text="暂无数据（API 未接入）">
      <el-table-column v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label" :min-width="col.minWidth || 100" />
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope>
          <el-button type="text" size="mini" disabled>编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </admin-page-frame>
</template>

<script>
import AdminPageFrame from './AdminPageFrame.vue'
import '../schools-admin.less'

export default {
  name: 'SchoolsAdminListPlaceholder',
  components: { AdminPageFrame },
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    columns: { type: Array, default: () => [] },
    showToolbar: { type: Boolean, default: true },
    showFilter: { type: Boolean, default: true }
  },
  data() {
    return { keyword: '' }
  }
}
</script>
